import './TopPromoComponent.css'
function TopPromoComponent() {
    return (
        < div className="get-7-days-for-free-then-upgra-parent" >
            <div className="get-7-days-container">
                <p className='get-7-days-container-text white font_family_inter'>Get 7 Days for free then {' '}
                    <a href='/premium' className='white'>
                        Upgrade to Unlimited Plan.
                    </a>
                    {/* {' '} for <span className='font_weight_600'>$9.99</span> */}
                </p>
            </div>
        </div >
    );
}


export default TopPromoComponent;